import { Injectable, signal } from '@angular/core';
import { RdataRecordsRequest } from '../../models/rdata-records-request';

@Injectable({
  providedIn: 'root'
})
export class SearchRequestService {

  rDataRecordsRequest = signal<RdataRecordsRequest | null>(null);

  constructor() { }

  saveRdataRecordsRequest(request: RdataRecordsRequest): void {
    this.rDataRecordsRequest.set(request);
  }

  clearRdataRecordsRequest(): void {
    this.rDataRecordsRequest.set(null);
  }

  getRDataRecordsRequest(): RdataRecordsRequest | null {
    return this.rDataRecordsRequest();
  }
}
